<svelte:head>
  <title>Sign-up | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->
{#if $uiState.activeModal}
          <svelte:component
            this={$uiState.activeModal.component}
            {...$uiState.activeModal.props}
          />
        {/if}
<section class="section hero">
  <div class="hero-body">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-two-fifths">
          <div class="card">
            <div class="card-header">
              <p class="card-header-title">
                <!-- svelte-ignore a11y-missing-attribute -->
                <a href="https://www.agoodthing.org.uk/">
                  <img src="/assets/img/logo_h.png" />
                </a>
              </p>
            </div>
            <div class="card-content">
              <div class="content">
                <div class="field">
                  <!-- svelte-ignore a11y-label-has-associated-control -->
                  <label class="label">Your work or charity email</label>
                  <div class="control">
                    <input
                      class="input"
                      type="email"
                      disabled={emailDisabled}
                      bind:value={email}
                      required
                    />
                  </div>
                </div>

                <div class="field">
                  <!-- svelte-ignore a11y-label-has-associated-control -->
                  <label class="label">Create password</label>
                  <div class="control">
                    <input
                      class="input"
                      type="password"
                      bind:value={password1}
                      required
                    />
                  </div>
                </div>
                <div class="field">
                  <!-- svelte-ignore a11y-label-has-associated-control -->
                  <label class="label">Repeat password</label>
                  <div class="control">
                    <input
                      class="input"
                      class:is-danger={!password2valid}
                      type="password"
                      bind:value={password2}
                      required
                    />
                  </div>
                  {#if showHelp && !password2valid}
                    <p class="help is-danger">Passwords do not match</p>
                  {/if}
                </div>

                <div class="block">
                  <label class="checkbox">
                    <input bind:checked={agreeTerms} type="checkbox">
                    I agree to the</label>
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <a
                    on:click={() => {
                      $uiState.activeModal = {
                        component: TermsModel
                      };
                    }}>terms of service</a>
                  
                </div>

                <div class="block">
                  <button
                    class="button is-primary"
                    class:is-loading={isLoading}
                    disabled={!isValid}
                    on:click={signup}>Sign up</button
                  >
                </div>

                <hr />

                <div class="block">
                  Already signed up? <a href="/">Log in</a>.
                </div>

                {#if errorMessage}
                  <div class="block">
                    <div class="notification is-danger is-light">
                      {errorMessage}
                    </div>
                  </div>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<script lang="ts">
  import { goto, params } from "@sveltech/routify";
  import { appState } from '../../lib/appState';
  import { uiState } from '../../lib/uiState';
  import TermsModel from './_components/TermsModal.svelte';
  import { ga } from '@beyonk/svelte-google-analytics';
  import { logging } from '../../lib/logging';

  let email : string, password1 : string, password2 : string;
  let errorMessage : string;
  let showHelp = false;
  let isLoading = false;
  let agreeTerms = false;

  $: isValid = email && password2valid && agreeTerms;

  const skipEmailVerification = true;

  let emailDisabled = false;

  if ($params.email) {
    email = $params.email;
    emailDisabled = true;
  }

  $: password2valid = password1 == password2;

  function signup() {
    if (!password2valid) {
      showHelp = true;
      return;
    }

    isLoading = true;

    const lowercaseEmail = email.toLowerCase();

    window.firebase
      .auth()
      .createUserWithEmailAndPassword(lowercaseEmail, password1)
      .then(() => {
        isLoading = false;
        // Signed in

        if (!skipEmailVerification) {
          window.firebase.auth().currentUser!.sendEmailVerification({
            url: `${$appState.origin}/`,
          });
        }

        ga.addEvent('sign_up', {});

        $goto("/start");
      })
      .catch((error) => {
        isLoading = false;
        errorMessage = error.message;
        ga.addEvent('error_signup', { message: errorMessage });
        logging.report(error.toString());
      });
  }
</script>
